export default __webpack_public_path__ + "static/media/NeomBackg.c5dbaf67.jpg";